import { VideosList } from "../helpers/interfaces/video";
import { ICategory, ICategoryDetailsArticles, ICategoryGroup, ITeamRank } from "../helpers/interfaces/ranking";
import { apiGet } from "./Api";

export const categoryService = {
    getCategoryArticles: (id: number) => apiGet<ICategoryDetailsArticles, string>("?op=categoria&id=" + id),
    getAll: () => apiGet<ICategory[], string>("?op=menuCategorie"),
    getRanking: (idGirone: string, stagione: string, giornata: number) => apiGet<ITeamRank[], string>("?op=classificaGirone&idGirone=" + idGirone + "&stagione=" + stagione + "&giornata=" + giornata),
    getGroup: (idGirone: string) => apiGet<ICategoryGroup, string>("?op=girone&id=" + idGirone),
    getVideoList: () => apiGet<VideosList, undefined>('?op=listaVideo'),
    getVideoData: (idVideo: string) => apiGet<VideosList, any>('?op=tipoVideo&id=' + idVideo)
}